import React, {useState,useEffect} from 'react';
import {RouteComponentProps, Link, Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import useReactRouter from 'use-react-router';
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import {Inc,News,Owner,ItemNameLengthMin,ItemNameLengthMax} from './Inc';
//import {Inc,Item,Owner,Dataset,DataErrorset,DataErrorset2,EventTag,,ItemPriceMin,ItemPriceMax,ItemPriceMaxHigh,ItemGuideLengthMax,ItemGuideNameLengthMax,ItemTagsMax,EventTagsMax,EventTagNameLengthMin,EventTagNameLengthMax,WordsLengthMax} from './Inc';
import Ajax from './Ajax';
import InputString from './InputString';
import InputNumber from './InputNumber';
import ColInput from './ColInput';
import RowData from './RowData';
import BottomButtons from './BottomButtons';
import DropImage from './DropImage';
import DropImageLight from './DropImageLight';
import Loading from './Loading';
import NewsConfirm from './NewsConfirm';
import Title from './Title';
import {Tools} from './Tools';

import Toast from './Toast';

interface Props {
	owner:Owner,
}

interface RCProps extends RouteComponentProps<{id:string}> {
	
}

//let newsId = 0;
//let errors:string[] = [];
//let imgs:{ [key: string]: string; } = {};

const NewsInput = (props:Props)=> {
	Ajax.setEditorId(props.owner.owner_id);

	const rcp:RCProps = useReactRouter();
	const classes = useStyles();
	const [states,setStates] = useState({
		news: Inc.defaultNews(),
		toast: "",
		newImgs:{} as { [key: string]: string; },
		errors: [] as string[],
		redirectId: 0,
		isConfirm: false,
		isLoading: true,
		notFound: false,
	});

	const load = ()=>{
		const newsId = parseInt(rcp.match.params.id);
		Ajax.send("news/get",{news_id:newsId,mode:"edit"},(res:any)=>{
			//console.log(res);
			if( res.ok ){
				setStates(prev=>({...prev,news:Inc.convNews(res.news),redirectId:0,isConfirm:false,notFound:false,isLoading:false}));
			} else {
				setStates(prev=>({...prev,notFound:true,isLoading:false}));
			}
		});
	}

	const addError = (name:keyof News,isError:boolean) =>{
		setStates(prev => {
			const errors = [...prev.errors];
			if( isError ){
				if( !errors.includes(name) ){
					errors.push( name );
				}
			} else {
				if( errors.includes(name) ){
					const index = errors.findIndex((v) => v===name);
					errors.splice(index,1);
				}
			}
			return { ...prev, errors: errors }
		});
	}

	const change = (name:keyof News,value:string)=>{
		//console.log(name,value);
		setStates(prev=>({...prev,"news":{...prev.news,[name]:value}}));
	}

    // const onChangeString = (name:keyof News) => (value: string,hasError: boolean) => {
    //     //const item = {...states.item,[name]:value};
    //     //validateItem({...states.item,[name]:value},name,hasError);
    //     setStates({...states,"news":{...states.news,[name]:value}});
    // };

	const changeImage = (id:string,src:string)=>{
		//imgs[ id ] = src;
		if (id.substring(0, 5) === "photo") {
			setStates(prev => {
				const newImgs = { ...prev.newImgs, [id]:src };
				let photo_ids = Tools.treatPhotos([ ...prev.news.photo_ids ],id,src,newImgs,3);
				return {
					...prev,
					news: {
						...prev.news,
						photo_ids: photo_ids,
					},
					newImgs: newImgs,
				};
			});
		} else {
			setStates(prev => {
				const newImgs = { ...prev.newImgs, [id]:src };
				return {
					...prev,
					newImgs: newImgs,
				};
			});
		}

	}

	const openConfirm = ()=>{
		//console.log("states",states);
		//console.log("imgs",imgs);
		//console.log("errors",errors);
		//setStates({...states,yesno:"この内容で登録します。\nよろしいですか？"});
		setStates({...states,isConfirm:true});
	}
	const closeConfirm = ()=>{
		setStates({...states,isConfirm:false});
	}
	const closeToast = ()=>{
		setStates({...states,toast:""});
	}

	const send = ()=>{
		//let news_id = 0;
		//if( states.news.news_id && states.news.news_id>0 ){
		//	news_id = states.news.news_id;
		//}
		setStates({...states,isLoading:true});
		Ajax.send("news/do",{...states.news,imgs:states.newImgs},(res:any)=>{
			//console.log(res);
			if( res.ok ){
				setStates({...states,redirectId:res.news_id,isLoading:false,isConfirm:false});
			} else {
				setStates({...states,toast:"登録できませんでした",isLoading:false,isConfirm:false});
			}
		},(err:any)=>{
			setStates({...states,toast:"登録できませんでした",isLoading:false,isConfirm:false});
		});
	}
	useEffect( ()=>{
		if( rcp.match.params.id && rcp.match.params.id!=="new" ){
			load();
		} else {
			setStates({...states,news:Inc.defaultNews(),newImgs:{},redirectId:0,toast:"",isConfirm:false,notFound:false,isLoading:false});
		}
	},[]);

	if( states.notFound ){
		return (
			<Redirect to="/"/>
		);
	}

	// let photo_ids:number[] = [];
	// for( let i=0 ; i<3 ; i++ ){
	// 	if( states.news.photo_ids[i] ){
	// 		photo_ids.push( states.news.photo_ids[i] );
	// 	} else {
	// 		photo_ids.push(0);
	// 	}
	// }

	if( states.isLoading ){
		return (
			<Loading isLoading={true}/>
		);
	}

	if( states.redirectId>0 ){
		const to = "/news/"+String(states.redirectId);
		return (
			<Redirect to={to}/>
		)
	}

	let id_view = "未定";
	if( states.news.news_id>0 ){
		id_view = String(states.news.news_id);
	}

	let toCancel = "/news";
	if( states.news.news_id>0 ){
		toCancel = "/news/"+String(states.news.news_id);
	}


	return (
		<div className={classes.root}>
			<Grid container spacing={2}>
				<Grid item xs={12} md={9}>
					<Paper className={classes.paper}>
						<Title text="ニュース編集" icon="portrait"/>
						<div style={{marginBottom:"1em"}}>
							お客さんに伝えたいニュースの内容を入力して下さい。イベントへの参加情報や近況報告など、どんな内容でも構いません。<br/>
							終了日は必要に応じて設定して下さい。<br/>
						</div>
						<Hidden mdUp implementation="js">
							<BottomButtons
								button1='この内容で登録する' onClick1={openConfirm} disabled1={states.errors.length>0}
								button2='登録しないで中断する' link2={toCancel}
							/>
						</Hidden>
						<Divider style={{marginBottom:"1em"}}/>

						<Grid container spacing={2}>
							<Grid item xs={12}>
								<ColInput name="タイトル" value={states.news.news_name} addError={addError} change={change} maxLength={30} id="news_name" helper="30文字以内" type="text" required/>
							</Grid>
							<Grid item xs={12}>
								<ColInput name="本文" value={states.news.news_body} addError={addError} change={change} id="news_body" helper="httpで始まるURLはリンクに自動変換されます" rows={10} type="textarea"/>
							</Grid>
							<Grid item xs={12}>
								<FormControl fullWidth={true}>
									<FormLabel component="label" style={{color:'#336600'}}>追加画像</FormLabel>
									<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '1em' }}>
									{states.news.photo_ids.map((img_id:number,index:number)=>{
										const key = "photo"+String(index+1);
										return (
											<div key={key} style={{ flex: '0 0 auto', width: '100px', height: '75px' }}>
												<DropImageLight noHelper={true} owner_id={props.owner.owner_id} data={states.newImgs[key]} img_id={img_id} id={key} change={changeImage}/>
											</div>
										);
									})}
									</div>
								</FormControl>
								<div className="formHelper">
									※PNG/JPEG/GIFで、3枚まで登録できます
								</div>
								<Divider style={{marginTop:"2em"}}/>
							</Grid>
							<Grid item xs={12} md={6}>
								<ColInput name="公開日" value={states.news.news_date} addError={addError} helper="未来の年月日を指定すると、その日の午前0時になるまで表示されません" change={change} maxLength={10} id="news_date" type="date" required/>
							</Grid>
							<Grid item xs={12} md={6}>
								<ColInput name="終了日" value={states.news.end_date} addError={addError} helper="指定した日を過ぎたらこのニュースは表示されなくなります（省略可）" change={change} maxLength={10} id="end_date" type="date"/>
							</Grid>

							<Grid item xs={12} md={6}>
								<ColInput name="状態" value={states.news.status} list={Inc.newsStatus} addError={addError} change={change} id="status" type="radio"/>
							</Grid>
						</Grid>

					</Paper>
				</Grid>
				<Grid item xs={12} md={3}>
					<Paper className={classes.paper}>
						<Title text="管理情報" size={2}/>
						<RowData name="ニュースID" value={id_view}/>
						<RowData name="状態" value={states.news.status_label}/>

						<Hidden smDown implementation="js">
							<Divider style={{margin:"1em 0"}}/>
							<Grid container spacing={1}>
								<Grid item xs={12} lg={12}>
									<Button variant="contained" color="primary" style={{width:"100%"}} onClick={openConfirm} disabled={states.errors.length>0}>この内容で登録する</Button>
								</Grid>
								<Grid item xs={12} lg={12}>
									<Link to={toCancel}><Button variant="outlined" style={{width:"100%"}}>登録しないで中断する</Button></Link>
								</Grid>
							</Grid>
						</Hidden>
					</Paper>
				</Grid>
			</Grid>
			<NewsConfirm isOpen={states.isConfirm} news={states.news} imgs={states.newImgs} send={send} close={closeConfirm} owner={props.owner}/>
			<Toast mes={states.toast} close={closeToast}/>
		</div>
	);
}

export default NewsInput;
